import { Injectable } from '@angular/core';
import * as PDFJS from 'pdfjs-dist/legacy/build/pdf';

@Injectable({
  providedIn: 'root'
})
export class EnvioSimpleMiniaturaService {
  /** Ancho util del marco A4 en tarjeta (139px - padding lateral 20px). */
  private static readonly ANCHO_MARCO_A4 = 119;

  private workerConfigurado = false;

  async generarDesdeArchivo(
    archivo: Blob,
    anchoObjetivo = EnvioSimpleMiniaturaService.ANCHO_MARCO_A4
  ): Promise<string> {
    const pdfBlob = this.normalizarPdfBlob(archivo);

    this.configurarWorker();

    const arrayBuffer = await pdfBlob.arrayBuffer();
    const data = new Uint8Array(arrayBuffer);
    const pdfDocument = await PDFJS.getDocument({ data }).promise;
    const pagina = await pdfDocument.getPage(1);
    const viewportBase = pagina.getViewport({ scale: 1 });
    const escalaAncho = anchoObjetivo / viewportBase.width;
    const escalaAlto = (anchoObjetivo * (297 / 210)) / viewportBase.height;
    const escala = Math.min(escalaAncho, escalaAlto);
    const viewport = pagina.getViewport({ scale: escala });

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('No se pudo crear el contexto del canvas');
    }

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await pagina.render({
      canvasContext: context,
      viewport
    }).promise;

    return canvas.toDataURL('image/jpeg', 0.85);
  }

  private normalizarPdfBlob(blob: Blob): Blob {
    if (blob.type === 'application/pdf') {
      return blob;
    }
    // fetch() desde UrlPdf (p. ej. SAS) suele devolver octet-stream o type vacio.
    return new Blob([blob], { type: 'application/pdf' });
  }

  private configurarWorker(): void {
    if (this.workerConfigurado) {
      return;
    }

    PDFJS.GlobalWorkerOptions.workerSrc =
      `https://cdn.jsdelivr.net/npm/pdfjs-dist@${PDFJS.version}/legacy/build/pdf.worker.js`;
    this.workerConfigurado = true;
  }
}